import React, { useEffect, useState } from "react";
import {
  getPartners,
  getPartner,
  setPartner,
  deletePartner,
} from "../../services/dictionary";
import Lists from "../../modules/hcmd/components/Lists";
import { useParams } from "react-router-dom";
import Forms from "../../modules/hcmd/components/Forms";
import { usePermission } from "../../services/auth";
import { sites } from "../../services/constants";

Partners.propTypes = {};

function Partners(props) {
  let { id } = props;

  const [isForm, setIsForm] = useState(false);

  const permissions = usePermission("dictionary");
  const params = useParams();
  if (!id && !isNaN(parseInt(params.id)) && parseInt(params.id) >= 0) {
    id = parseInt(params.id);
    if (!isForm) {
      setIsForm(true);
    }
  } else if (!isNaN(parseInt(id)) && parseInt(id) >= 0 && !isForm) {
    setIsForm(true);
  } else if (isForm) {
    setIsForm(false);
  }

  // ide jonnek a tipusnal hasznalt egyeb adatok deklaralasa
  const siteArr = sites;

  // ide jon az oszlopok deklaralasa
  const columns = [
    {
      field: "id",
      fieldType: "number",
      hide: true,
    },
    {
      field: "name",
      fieldType: "text",
      headerName: "Megnevezés",
      validation: {
        required: true,
        minLength: 3,
      },
    },
    {
      field: "slug",
      fieldType: "text",
      headerName: "link",
      disabled: id > 0,
      validation: {
        required: true,
        minLength: 3,
      },
    },
    {
      field: "contact",
      fieldType: "text",
      headerName: "kapcsolattartó",
    },
    {
      field: "isActive",
      fieldType: "boolean",
      defaultValue: true,
      headerName: "Státusz",
      width: 100,
      valueGetter: (params) => {
        return params.row.isActive ? "aktív" : "inaktív";
      },
    },
  ];

  // ide jon a fejlec deklaralasa
  const header = {
    title: "Exportálási lehetőségek",
    url: "/dictionary/partners",
    item: "exportálási lehetőség",
  };

  return (
    <>
      {isForm && (
        <Forms
          editable={true}
          id={id}
          header={header}
          permissions={permissions}
          columns={columns}
          getFunc={getPartner}
          setFunc={setPartner}
          sites={siteArr}
        ></Forms>
      )}
      {!isForm && (
        <Lists
          header={header}
          permissions={permissions}
          getFunc={getPartners}
          isDictionary={true}
          deleteFunc={deletePartner}
          columns={columns}
          sites={siteArr}
        ></Lists>
      )}
    </>
  );
}

export default Partners;
